import { Track } from 'livekit-client';

/**
 * useTracks can keep a ScreenShare row briefly after the user stops sharing; the
 * MediaStreamTrack may sit in readyState "ended" while the last frame stays painted.
 * Treat that as inactive so we leave ScreenShareView and avoid a frozen main stage.
 */
export function isRenderableScreenShareTrack(t) {
  if (!t || t.source !== Track.Source.ScreenShare) return false;
  const pub = t.publication;
  if (!pub) return false;
  const vt = pub.videoTrack ?? pub.track;
  if (vt) {
    const mst = vt.mediaStreamTrack;
    if (mst && mst.readyState === 'ended') return false;
    return true;
  }
  /** Subscribed but WebRTC track not attached yet — keep stage mounted so VideoTrack can finish setup. */
  return Boolean(pub.isSubscribed);
}
